import { css } from 'wiloke-react-core';

export const container = css`
  debug: FormSchemaSetting__container;
  padding: 8px 14px;
`;
